import { React, useRef } from 'react';
import styled from 'styled-components';

export default function PointInput(props) {
  const { value, setValue } = props;
  
  const InputRef = useRef();

  function handleChange(e) {
    const curValue = e.target.value
		const newValue = curValue.replace(/[^0-9]/g, '')

    if (newValue < 999999)
		  setValue(newValue);
  }

  function handleFocus() {
    // InputRef.current.style.border = `1px solid #FF8B48`;
  }

  function handleBlur() {
    // InputRef.current.style.border = `1px solid #DFDFDF`;
  }

  return (
    <TopLevelWrapper>
        <Input 
          ref={InputRef}
          placeholder='0'
          value={value || ''}
          // disabled={disabled}
          onFocus={handleFocus}
          onChange={handleChange}
          onBlur={handleBlur}/>
        <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='defaul'>POINT</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Input = styled.input`
  width: 49px;
  height: 28px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;
  padding: 0px 10px;

  border: 1px solid #DFDFDF;
  border-radius: 5px;

  outline: none;

  color: #000000;
  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

  ::placeholder {
    color: #CBCBCB;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;